import React from "react";
import { useSettings } from "../context/SettingsContext";
import { useContent } from "../context/ContentContext";
import { whatsappLink } from "../lib/format";
import { Button } from "../components/ui/button";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { MessageCircle, Mail, MapPin } from "lucide-react";

export default function Contact() {
  const { settings } = useSettings();
  const { content } = useContent();
  if (!settings || !content) return null;
  const c = content.contact;

  return (
    <div className="mx-auto max-w-5xl px-4 py-12 sm:px-6 lg:py-20">
      <h1 className="font-serif text-4xl font-semibold text-[#2C1A14] sm:text-5xl">{c.title}</h1>
      <p className="mt-3 text-[#6E544A]">{c.subtitle}</p>

      <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-4">
        <a
          href={whatsappLink(settings.whatsapp_number, "Bonjour Le Dressing de Yoyo !")}
          target="_blank" rel="noreferrer"
          data-testid="contact-whatsapp"
          className="flex items-center gap-3 rounded-xl bg-white p-5 ring-1 ring-[#E8D5CE] transition-all hover:shadow-md sm:col-span-1"
        >
          <MessageCircle className="h-6 w-6 shrink-0 text-[#25D366]" />
          <div className="min-w-0">
            <p className="text-xs uppercase tracking-wide text-[#9B7E73]">WhatsApp</p>
            <p className="text-sm font-medium text-[#2C1A14]">{settings.whatsapp_number}</p>
          </div>
        </a>
        <div className="flex items-center gap-3 rounded-xl bg-white p-5 ring-1 ring-[#E8D5CE] sm:col-span-2">
          <Mail className="h-6 w-6 shrink-0 text-[#D76E4D]" />
          <div className="min-w-0 flex-1">
            <p className="text-xs uppercase tracking-wide text-[#9B7E73]">Email</p>
            <p className="whitespace-nowrap text-sm font-medium text-[#2C1A14]">{settings.contact_email}</p>
          </div>
        </div>
        <div className="flex items-center gap-3 rounded-xl bg-white p-5 ring-1 ring-[#E8D5CE] sm:col-span-1">
          <MapPin className="h-6 w-6 shrink-0 text-[#D76E4D]" />
          <div className="min-w-0">
            <p className="text-xs uppercase tracking-wide text-[#9B7E73]">Adresse</p>
            <p className="text-sm font-medium text-[#2C1A14]">{settings.contact_adresse}</p>
          </div>
        </div>
      </div>

      <a href={whatsappLink(settings.whatsapp_number, "Bonjour Le Dressing de Yoyo !")} target="_blank" rel="noreferrer">
        <Button data-testid="contact-whatsapp-button" className="mt-6 rounded-full bg-[#25D366] px-7 py-6 text-white hover:bg-[#1da851]">
          <MessageCircle className="mr-2 h-5 w-5" /> Nous écrire sur WhatsApp
        </Button>
      </a>

      <section className="mt-14">
        <h2 className="mb-4 font-serif text-2xl font-medium text-[#2C1A14]">Questions fréquentes</h2>
        <Accordion type="single" collapsible className="rounded-xl bg-white px-5 ring-1 ring-[#E8D5CE]">
          {(settings.faq || []).map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="text-left text-[#2C1A14]">{f.q}</AccordionTrigger>
              <AccordionContent className="text-[#6E544A]">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </section>

      <section className="mt-10 rounded-xl bg-[#F5E8E3] p-6">
        <h3 className="font-serif text-xl font-medium text-[#2C1A14]">Politique de retour</h3>
        <p className="mt-2 text-sm leading-relaxed text-[#6E544A]">{settings.return_policy}</p>
      </section>
    </div>
  );
}
